import { render, staticRenderFns } from "./CustomMenuBrowseStyles.vue?vue&type=template&id=5fc393f6"
import script from "./CustomMenuBrowseStyles.vue?vue&type=script&lang=ts"
export * from "./CustomMenuBrowseStyles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports